/* eslint-disable no-console */
import { createTheme, responsiveFontSizes } from "@material-ui/core/styles";

import Colors from "./colors";

const breakpointValues = {
  xs: 0,
  ssm: 460,
  sm: 600,
  md: 960,
  lg: 1280,
  xl: 1600,
  xxl: 1920,
};

function createLightTheme({
  backgroundColor,
  paperBackgroundColor,

  backgroundDisabled,
  textDisabledColor,
  textPrimaryColor,
  textSecondaryColor,
  buttonTextColor,
  buttonBackgroundColor,

  textTertiaryColor,
  inputBackgroundColor,
}: any) {
  return createTheme({
    breakpoints: {
      keys: ["xs", "sm", "md", "lg", "xl"],
      values: {
        xs: 0,
        sm: 600,
        md: 960,
        lg: 1280,
        xl: 1600,
      },
      up: (key) => `@media (min-width:${breakpointValues[key]}px)`,
      down: (key) => `@media (max-width:${breakpointValues[key] - 1}px)`,
    },
    palette: {
      primary: {
        contrastText: inputBackgroundColor,
        main: buttonBackgroundColor,
      },
      secondary: {
        main: buttonTextColor,
        contrastText: buttonBackgroundColor,
      },
      error: {
        main: "#f00",
        contrastText: textSecondaryColor,
      },
      text: {
        primary: textPrimaryColor,
        secondary: textSecondaryColor,

        disabled: backgroundDisabled,
        hint: textPrimaryColor,
      },
      background: {
        paper: paperBackgroundColor,

        default: backgroundColor,
      },
      action: {
        active: buttonBackgroundColor,
        hover: buttonBackgroundColor + "60",
        hoverOpacity: 0.04,
        selected: textTertiaryColor,
        selectedOpacity: 0.08,
        disabled: textDisabledColor,
        disabledBackground: backgroundDisabled,
        disabledOpacity: 0.38,
        focus: textTertiaryColor,
        focusOpacity: 0.12,
        activatedOpacity: 0.12,
      },
    },

    shape: {
      borderRadius: 4,
    },
  });
}

//TODO mudar as cores de acordo com a necessidade
const Light = createLightTheme({
  backgroundColor: Colors.grayBackground,

  paperBackgroundColor: Colors.whiteBackground,
  paperColorHover: Colors.lightGray,
  backgroundAlternativeColor: Colors.whiteBackground,
  backgroundDisabled: Colors.disabled,
  textDisabledColor: Colors.lightGray,
  textPrimaryColor: Colors.black,
  textSecondaryColor: Colors.whiteBackground,
  textTertiaryColor: Colors.gray,
  buttonTextColor: Colors.whiteBackground,
  buttonBackgroundColor: Colors.black,
  contrastColor: Colors.whiteBackground,
  inputBackgroundColor: Colors.inputGray,
});

const Themes = {
  Light: responsiveFontSizes(Light),
};

export default Themes;
